import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_cancel_order_item: { message: "idle" },
};

export const tenant_cancel_order_item_Slice = createSlice({
 name: "tenant_cancel_order_item",
 initialState,
 reducers: {
  success_tenant_cancel_order_item: (state, action) => {
   state.tenant_cancel_order_item = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_cancel_order_item: (state, action) => {
   state.tenant_cancel_order_item = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_cancel_order_item: (state) => {
   state.tenant_cancel_order_item = { status: app_consts.IDLE };
  },
  loading_tenant_cancel_order_item: (state) => {
   state.tenant_cancel_order_item = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_cancel_order_item, fail_tenant_cancel_order_item, reset_tenant_cancel_order_item, loading_tenant_cancel_order_item } = tenant_cancel_order_item_Slice.actions;

export default tenant_cancel_order_item_Slice.reducer;